// extracted by mini-css-extract-plugin
export default {"ellipsis":"ellipsis-OAAUPyGI","bounce":"bounce-qmuyZOZ1","dot":"dot-pSf4v3vK","fade":"fade-CEfGy0BA","large":"large-q77LNGVT"};